var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.mobile ? "productShopMoble" : "",
        _vm.isTurquoise ? "turquoiseTheme" : "",
        _vm.translationMode ? "isTranslationMode" : "",
        this.$root.admin ? "hasAdminSettings" : "",
      ],
      attrs: { id: "integrationTest" },
    },
    [
      this.$root.admin
        ? _c("p", { staticClass: "heading integrationTestSettings" }, [
            this.$root.admin
              ? _c(
                  "svg",
                  {
                    staticClass: "fontAwesomeIcon",
                    class: ["settings", _vm.settingsMode ? "active" : ""],
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 512 512",
                    },
                    on: {
                      click: function ($event) {
                        _vm.settingsMode = !_vm.settingsMode
                      },
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.settingsMode && this.$root.admin
        ? _c("settingsComponent", { on: { saveSettings: _vm.setSettings } })
        : _vm._e(),
      _c("div", { staticClass: "priceListToolBar" }, [
        _c(
          "div",
          { staticClass: "horizontalLinkBoxesSlot" },
          [_c("horizontalLinkBoxes")],
          1
        ),
        this.$root.settings.showFilter && _vm.mobile
          ? _c(
              "button",
              {
                staticClass: "mobileFilterBtn",
                on: {
                  click: function ($event) {
                    _vm.mobileFilterOpen = true
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-sliders-h" }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$root.language.wsm_Filter || "Filter")),
                ]),
                _vm.$store.state.priceListFilterPills.length > 0
                  ? _c("span", { staticClass: "filterBadge" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$store.state.priceListFilterPills.length) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        !_vm.mobile
          ? _c("div", { staticClass: "viewToggle" }, [
              _c(
                "button",
                {
                  class: [
                    "listButton",
                    "sortBtn",
                    _vm.view == "list" ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      _vm.view = "list"
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-bars" })]
              ),
              _c(
                "button",
                {
                  class: [
                    "gridButton",
                    "sortBtn",
                    _vm.view == "grid" ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      _vm.view = "grid"
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-th" })]
              ),
            ])
          : _vm._e(),
      ]),
      this.$root.settings.showFilter
        ? _c("filterList", {
            ref: "desktopFilter",
            attrs: { "hide-filters": _vm.mobile },
          })
        : _vm.leftColumnActive
        ? _c("div", { ref: "leftColumnHost", staticClass: "filterContainer" }, [
            _c("div", {
              ref: "relocatedLeftBox",
              staticClass: "relocatedLeftBox",
            }),
          ])
        : _vm._e(),
      _c("priceList", {
        attrs: { view: _vm.view, "constrain-width": _vm.leftColumnActive },
      }),
      _c("transition", { attrs: { name: "drawer-fade" } }, [
        _vm.mobileFilterOpen
          ? _c("div", {
              staticClass: "mobileFilterOverlay",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  _vm.mobileFilterOpen = false
                },
              },
            })
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "mobileFilterDrawer",
          class: { open: _vm.mobileFilterOpen },
          style: _vm.drawerSwipeStyle,
        },
        [
          _c(
            "div",
            {
              staticClass: "drawerHandle",
              on: {
                click: function ($event) {
                  _vm.mobileFilterOpen = false
                },
                touchstart: _vm.onDrawerTouchStart,
                touchmove: _vm.onDrawerTouchMove,
                touchend: _vm.onDrawerTouchEnd,
              },
            },
            [_c("span", { staticClass: "drawerHandleBar" })]
          ),
          _c(
            "div",
            {
              ref: "drawerContent",
              staticClass: "drawerContent",
              on: {
                touchstart: _vm.onContentTouchStart,
                touchmove: _vm.onContentTouchMove,
                touchend: _vm.onDrawerTouchEnd,
              },
            },
            [
              this.$root.settings.showFilter
                ? _c("filterList", {
                    ref: "mobileFilter",
                    attrs: { "show-counts": true, "filters-only": true },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }